import { render, staticRenderFns } from "./campaign-edit.vue?vue&type=template&id=cdae9652&scoped=true&"
import script from "./campaign-edit.vue?vue&type=script&lang=js&"
export * from "./campaign-edit.vue?vue&type=script&lang=js&"
import style0 from "./campaign-edit.vue?vue&type=style&index=0&id=cdae9652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdae9652",
  null
  
)

export default component.exports